<div class="search-location-filter" [ngClass]="{'loading': isInLoadingState}">
  <button role="button" class="search-location-filter__my-location" (click)="getBrowserLocation()">
    <span><brt-icon [icon]="'direction'"></brt-icon></span>
    <span>Mein Standort</span>
  </button>

  <div class="search-location-filter__distance">
    <swiper [config]="distanceSliderOptions">
      <ng-template swiperSlide>
        <div class="search-location-filter__distance-label">
          <div class="search-location-filter__distance-label-icon"><brt-icon icon="radius"></brt-icon></div>
          <div class="search-location-filter__distance-label-text">Umkreis</div>
        </div>
      </ng-template>

      <ng-template swiperSlide><div class="search-location-filter__distance-item" [ngClass]="{active: ($currentDistanceValue | async) === 30}" (click)="setProvidersDistance(30)">30km</div></ng-template>
      <ng-template swiperSlide><div class="search-location-filter__distance-item" [ngClass]="{active: ($currentDistanceValue | async) === 50}" (click)="setProvidersDistance(50)">50km</div></ng-template>
      <ng-template swiperSlide><div class="search-location-filter__distance-item" [ngClass]="{active: ($currentDistanceValue | async) === 80}" (click)="setProvidersDistance(80)">80km</div></ng-template>
      <ng-template swiperSlide><div class="search-location-filter__distance-item" [ngClass]="{active: ($currentDistanceValue | async) === 100}" (click)="setProvidersDistance(100)">100km</div></ng-template>
      <ng-template swiperSlide><div class="search-location-filter__distance-item" [ngClass]="{active: ($currentDistanceValue | async) === 120}" (click)="setProvidersDistance(120)">120km</div></ng-template>
    </swiper>
  </div>


  <div class="search-location-filter__grid-title">Nach Bezirk suchen</div>

  <div class="search-location-filter__grid">
    <div class="search-location-filter__grid-item" *ngFor="let item of districts">
      <div class="search-location-filter__grid-item-icon">
        <div class="search-location-filter__grid-item-icon-sizer">
          <button role="button" class="search-location-filter__grid-item-icon-content" [attr.aria-labelledby]="'district-label-' + item.id" [ngClass]="{'active': isActive(item)}" (click)="toggleDistrict(item)">
            <brt-icon [icon]="item.icon"></brt-icon>
          </button>
        </div>
      </div>

      <div class="search-location-filter__grid-item-label" [id]="'district-label-' + item.id">{{item.name}}</div>
    </div>
  </div>

  <div class="search-location-filter__footer">
    <button role="button" [tabindex]="activeDistricts.length === 0 ? -1 : 0" class="search-location-filter__footer-reset" [ngClass]="{'hidden': activeDistricts.length === 0}" (click)="resetFilter()">
      <span class="search-location-filter__footer-reset-title">Auswahl löschen</span>
      <span class="search-location-filter__footer-reset-number">{{activeDistricts.length}}</span>
    </button>

    <div class="search-location-filter__footer-save" (click)="saveFilter()">
      <brt-button [title]="'Filter anwenden'"></brt-button>
    </div>
  </div>
</div>
